import { render } from "./SortByMenu.vue?vue&type=template&id=3824078a&scoped=true&ts=true"
import script from "./SortByMenu.vue?vue&type=script&lang=ts"
export * from "./SortByMenu.vue?vue&type=script&lang=ts"

import "./SortByMenu.vue?vue&type=style&index=0&id=3824078a&scoped=true&lang=css"

import exportComponent from "/Users/alcyone/Desktop/front/chapito-static/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3824078a"]])

export default __exports__